import { Portal as HeadlessUIPortal } from "@headlessui/react";
import { FC, ReactNode } from "react";
import { createPortal } from "react-dom";

export interface PortalProps {
  children: ReactNode;
  container?: HTMLElement | null;
}

export const Portal: FC<PortalProps> = ({ children, container }) => {
  if (container) {
    return createPortal(children, container);
  }

  return <HeadlessUIPortal>{children}</HeadlessUIPortal>;
};
